import { useApolloClient } from "@apollo/client";
import React from "react";
import { AlertContext } from "../../contexts";
import { GET_ACCESS_GATES_BY_PROPERTY_ID } from "../../graphql/securityManager/queries";
import { AlertProps, InAndOutOption, InOutStatusVW, SemiBold, StayTypetOption } from "../../utils";
import { FilterGenerator } from "../filterGenerator";
import { withNamespaces } from "react-i18next";

const VisitorSecurityFilter = (
    {
        open = "",
        close = () => false,
        apply = () => false,
        filterData = {},
        clientId = "",
        property = {},
        filterKeys = [],
        t
    }
) => {
    const client = useApolloClient()
    const alert = React.useContext(AlertContext)
    // Function to load Async Select Options
    const loadOptions = async (
        search = "",
        array = [],
        handleLoading = null,
        type
    ) => {
        let result, query, offset, limit, variables = 0
        limit = 10
        if (search && !Boolean(array?.length)) { offset = 0 }
        else { offset = array?.length }
        switch (type) {
            case "access_gates_master":
                query = GET_ACCESS_GATES_BY_PROPERTY_ID
                variables = { clientID: clientId, property: property.label === "All Properties" ? property?.value : [property?.value], offset, limit, search }
                result = await networkCallBack(query, variables, handleLoading)
                return {
                    options: [...result?.access_gates_master],
                    hasMore: (array?.length + result?.access_gates_master?.length) < result?.count[0]?.count
                }
            default:
                return { options: [] }
        }
    }

    // Function for network callback for Async Select Options
    const networkCallBack = async (query, variables = {}, handleLoading) => {
        const options = await client.query({
            query, fetchPolicy: "network-only", variables
        }).then((r) => {
            let main = r?.data
            handleLoading()
            return main
        }).catch((e) => {
            handleLoading()
            alert.setSnack({
                ...alert, open: true, msg: t("Some Thing Went Wrong"),
                severity: AlertProps.severity.error,
            })
            return null
        })
        return options
    }

    const object = {
        unitID: {
            component: "select",
            value: filterData?.unit_id,
            options: [],
            isMulti: true,
            label: t("Unit ID"),
            state_name: "unit_id",
            debounceTimeout: 800,
            isPaginate: true,
            labelColor: "#98a0ac",
            labelSize: "12px",
            fontFamily: SemiBold
        },
        accessGate: {
            component: "select",
            value: filterData?.gate,
            options: [],
            isMulti: true,
            label: t("Gate"),
            state_name: "gate",
            placeholder: t("Select gate"),

            loadOptions: (search, array, handleLoading) =>
                loadOptions(search, array, handleLoading, "access_gates_master"),
            debounceTimeout: 800,
            isPaginate: true,
            labelColor: "#98a0ac",
            labelSize: "12px",
            fontFamily: SemiBold
        },
        status: {
            component: "toggleButton",
            value: filterData?.status,
            options: InAndOutOption,
            isMulti: true,
            state_name: "status",
            label: t("Status"),
            labelColor: "#98a0ac",
            labelSize: "12px",
            fontFamily: SemiBold
        },
        reqDate: {
            component: "minAndmaxDate",
            placeholder: {
                startLabel: t("Start"),
                endLabel: t("End"),
            },
            state_name: "createdDate",
            value: filterData?.createdDate,
            minMaxlabel: t("Created Date"),
            labelColor: "#98a0ac",
            labelSize: "12px",
            fontFamily: SemiBold,
            height: "35%"
        },
        checkInDate: {
            component: "minAndmaxDate",
            placeholder: {
                startLabel: t("Start"),
                endLabel: t("End"),
            },
            state_name: "checkInDate",
            value: filterData?.checkInDate,
            minMaxlabel: t("Check In Date"),
            labelColor: "#98a0ac",
            labelSize: "12px",
            fontFamily: SemiBold,
            height: "35%"
        },
        checkOutDate: {
            component: "minAndmaxDate",
            placeholder: {
                startLabel: t("Start"),
                endLabel: t("End"),
            },
            state_name: "checkOutDate",
            value: filterData?.checkOutDate,
            minMaxlabel: t("Check Out Date"),
            labelColor: "#98a0ac",
            labelSize: "12px",
            fontFamily: SemiBold,
            height: "35%"
        },
        requestedFromDate: {
            component: "minAndmaxDate",
            placeholder: {
                startLabel: t("Start"),
                endLabel: t("End"),
            },
            state_name: "requestedFromDate",
            value: filterData?.requestedFromDate,
            minMaxlabel: t("Requested From"),
            labelColor: "#98a0ac",
            labelSize: "12px",
            fontFamily: SemiBold,
            height: "35%"
        },
        requestedToDate: {
            component: "minAndmaxDate",
            placeholder: {
                startLabel: t("Start"),
                endLabel: t("End"),
            },
            state_name: "requestedToDate",
            value: filterData?.requestedToDate,
            minMaxlabel: t("Requested To"),
            labelColor: "#98a0ac",
            labelSize: "12px",
            fontFamily: SemiBold,
            height: "35%"
        },
        stayType: {
            component: "select",
            value: filterData?.stayType,
            options: StayTypetOption,
            isMulti: true,
            label: t("Stay Type"),
            placeholder: t("Select stay type"),
            state_name: "stayType",
            labelColor: "#98a0ac",
            labelSize: "12px",
            fontFamily: SemiBold
        },
        inOutStatusVW: {
            component: "select",
            value: filterData?.inOutStatus,
            options: InOutStatusVW,
            isMulti: true,
            label: t("In/Out Status"),
            state_name: "inOutStatus",
            labelColor: "#98a0ac",
            labelSize: "12px",
            fontFamily: SemiBold
        },
    }
    const components = () => {
        let data = filterKeys?.map(i => object[i])
        return data
    }
    return (
        <FilterGenerator open={open} onClose={close}
            onApply={(value) => apply(value)}
            components={components()} />
    )
}
export default withNamespaces("visitorSecurityFilter")(VisitorSecurityFilter)

